import React, { useState } from 'react'
import { post } from '../../Services/ApiHandler'
import { URLS } from '../../Services/Constant'
import { toast } from 'react-toastify'

const SosRespondPop = ({ onclose ,data}) => {
    const [description, setDescription] = useState('')
    
    const onSubmit = async () => {
        let payload = {
          sos_id: data?.id,
          response_message: description,
        };
        let res = await post(URLS.SOS_ALERTS_RESPOND, payload)
        if (res?.status === 'success') {
            toast.success(res?.message)
            onclose?.('api')
        }
    }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onclose}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: 30,
          width: 680,
          maxWidth: "90%",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ marginBottom: 24 }}>
          <p style={{ marginBottom: 8, fontWeight: 500 }}>Description</p>
            <>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value.slice(0, 150))}
                rows={4}
                maxLength={150}
                placeholder="Enter description"
                style={{
                  width: "100%",
                  background: "#f5f5f7",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 14px",
                  minHeight: 60,
                  fontSize: 14,
                  fontFamily: "inherit",
                  resize: "vertical",
                  boxSizing: "border-box",
                }}
              />
              <p
                style={{
                  textAlign: "right",
                  fontSize: 12,
                  color: description.length >= 150 ? "#DC2626" : "#888",
                  marginTop: 4,
                  marginBottom: 0,
                }}
              >
                {description.length}/150
              </p>
            </>
        </div>

        <div style={{ display: "flex", justifyContent: "end" }}>
          <div>
            <button
              onClick={onclose}
              style={{
                border: "1px solid #ccc",
                borderRadius: 20,
                padding: "8px 28px",
                background: "#fff",
                cursor: "pointer",
              }}
            >
              Close
            </button>
            &nbsp;
              <button
                onClick={onSubmit}
                disabled={!description}
                style={{
                  border: "1px solid #ccc",
                  borderRadius: 20,
                  padding: "8px 28px",
                  background: !description ? "#A7D9B8" : "#16A34A",
                  cursor: !description ? "not-allowed" : "pointer",
                  color: "#fff",
                }}
              >
                Respond
              </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SosRespondPop
